<template>
  <el-select
    v-model="value"
    multiple
    placeholder="Hours to show"
    @update:modelValue="updated"
  >
    <el-option
      v-for="item in options"
      :key="item.type_id"
      :label="item.label"
      :value="item.type_id"
    />
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import { Timeslot, TimeslotLabels } from '@/api/types'

export default defineComponent({
  name: 'TimeslotsSelect',
  props: {
    modelValue: {
      type: Array,
      required: true
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const options = TimeslotLabels
    const updated = (newValue: Array<Timeslot>) => {
      context.emit('update:modelValue', newValue)
    }
    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )
    return { options, updated, value }
  }
})
</script>
